// @ts-nocheck
import { fabric } from 'fabric';
import { ANNOTATION_TYPE, DEFAULT_FONT } from '../../../config';
import { mVToPx, pxToMv } from '../../../ui/helper';

let TextAnnotation;

(function () {
  TextAnnotation = function (
    cv: any,
    points: any,
    offsetX: any,
    config: any,
    verticalChannelPlacement: any,
    channelIndex: any,
  ) {
    this.type = ANNOTATION_TYPE.TEXT;
    this.canvas = cv;
    this.channelIndex = channelIndex;
    this.config = config;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.isVisible = true;
    this.x = points.x;
    this.y = points.y;
    this.isBeingSelected = false;
    this.spp = (config.samplingRate * config.wndDuration) / config.width;
    this.xr = offsetX + this.x * this.spp;
    this.yr = pxToMv(this.verticalChannelPlacement, this.config, this.y, this.channelIndex);
    this.stringValue = '';
  };

  TextAnnotation.prototype.draw = function () {
    this.text = new fabric.IText(this.stringValue, {
      left: this.x,
      top: this.y,
      padding: 3,
      hasControls: false,
      fontSize: 14,
      width: 100,
      height: 50,
      hoverCursor: 'arrow',
      fill: 'red',
      borderColor: 'red',
      editingBorderColor: 'red',
      fontFamily: DEFAULT_FONT,
    });
    this.isDrawing = true;
    this.canvas.add(this.text);
    this.canvas.setActiveObject(this.text);
    this.text.enterEditing();
  };

  TextAnnotation.prototype.drawImport = function () {
    this.text = new fabric.IText(this.stringValue, {
      left: this.x,
      top: this.y,
      padding: 3,
      hasControls: false,
      fontSize: 14,
      width: 100,
      height: 50,
      hoverCursor: 'arrow',
      fill: 'blue',
      borderColor: 'red',
      editingBorderColor: 'red',
      fontFamily: DEFAULT_FONT,
    });
    this.canvas.add(this.text);
  };

  TextAnnotation.prototype.render = function () {
    this.canvas.renderAll();
  };

  TextAnnotation.prototype.update = function (delta: any, displayedChannelsArr: any) {
    this.x += delta.dx;
    this.y += delta.dy;
    this.xr += delta.dx * this.spp;
    for (let i = 0; i < displayedChannelsArr.length; i += 1) {
      if (this.channelIndex === displayedChannelsArr[i]) {
        this.yr = pxToMv(this.verticalChannelPlacement, this.config, this.y, i);
      }
    }
    this.text.set({
      left: this.x,
      top: this.y,
    });
    this.text.setCoords();

    // *: Editing out-range
    // if (this.y + this.text.height >= 0 && this.y <= this.config.height && this.x + this.text.width >= 0 && this.x <= this.config.width) {
    //   this.isVisibility(true);
    // } else {
    //   this.isVisibility(false);
    // }
  };

  TextAnnotation.prototype.updateConfig = function (
    config: any,
    offsetX: any,
    verticalChannelPlacement: any,
    displayedChannelsArr: any,
  ) {
    this.config = config;
    this.verticalChannelPlacement = verticalChannelPlacement;
    for (let i = 0; i < displayedChannelsArr.length; i += 1) {
      if (this.channelIndex === displayedChannelsArr[i]) {
        this.spp = (config.samplingRate * config.wndDuration) / config.width;
        this.x = (this.xr - offsetX) / this.spp;
        this.y = mVToPx(verticalChannelPlacement, config, this.yr, i);

        this.text.set({
          left: this.x,
          top: this.y,
          fontSize: 14,
        });
        this.text.setCoords();
        this.isVisibility(true);
        // *: Editing out-range
        // if (this.y + this.text.height >= 0 && this.y <= this.config.height) {
        //   this.isVisibility(true);
        // } else {
        //   this.isVisibility(false);
        // }
        break;
      } else {
        this.isVisibility(false);
      }
    }
  };

  TextAnnotation.prototype.updateChannelIdx = function (channelIndex: any) {
    this.channelIndex = channelIndex;
  };

  TextAnnotation.prototype.isEditing = function () {
    return this.text.isEditing;
  };

  TextAnnotation.prototype.scroll = function (offsetX: any, displayedChannelsArr: any) {
    for (let i = 0; i < displayedChannelsArr.length; i += 1) {
      if (this.channelIndex === displayedChannelsArr[i]) {
        this.x = (this.xr - offsetX) / this.spp;
        this.text.set({ left: this.x });
        this.text.setCoords();

        if (
          (this.x < 0 || this.x > 945) &&
          (this.x + this.text.width < 0 || this.x + this.text.width > 945)
        ) {
          this.isVisibility(false);
        } else {
          this.isVisibility(true);
        }
        break;
      }
    }
  };

  TextAnnotation.prototype.isSelected = function (pointer: any) {
    if (
      pointer.y > this.y - 3 &&
      pointer.y < this.y + this.text.height + 4 &&
      pointer.x > this.x - 3 &&
      pointer.x < this.x + this.text.width + 4
    ) {
      this.isBeingSelected = true;
      return true;
    }
    this.isBeingSelected = false;
    return false;
  };

  TextAnnotation.prototype.select = function () {
    this.text.set({ fill: 'red', hasBorders: true });
  };

  TextAnnotation.prototype.deselect = function () {
    this.text.set({ fill: 'blue', hasBorders: false });
    if (!this.text.text) {
      this.canvas.remove(this.text);
    }
    this.isDrawing = false;
  };

  TextAnnotation.prototype.isVisibility = function (isVisibility: any) {
    this.isVisible = isVisibility;
    this.text.visible = isVisibility;
  };

  TextAnnotation.prototype.getJSONObject = function () {
    // *: Convert the specific character to prevent error while parsing JSON to Object
    const str = this.text.text.replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t');
    return {
      type: this.type,
      channelIndex: this.channelIndex,
      xr: this.xr,
      yr: this.yr,
      text: str,
    };
  };

  TextAnnotation.prototype.import = function (data: any) {
    this.channelIndex = data.channelIndex;
    this.xr = data.xr;
    this.yr = data.yr;
    this.stringValue = data.text;

    this.x = this.xr / this.spp;
    this.y = mVToPx(this.verticalChannelPlacement, this.config, this.yr, this.channelIndex);
    // this.draw();
    this.drawImport();
  };
})();

export { TextAnnotation };
export default { TextAnnotation };
